import { Helmet } from "react-helmet-async";
import { Compass } from "lucide-react";
import { ButtonLink, EmptyState } from "@/components/ui";

export function NotFoundPage() {
  return (
    <div className="container-rs relative py-16">
      <Helmet>
        <title>Page not found · RealityStore</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="aurora opacity-50" aria-hidden />
      <EmptyState
        className="relative"
        icon={<Compass />}
        title="This page drifted out of reality"
        description="The link may be broken or the page may have moved."
        action={<ButtonLink to="/">Back to home</ButtonLink>}
      />
    </div>
  );
}
